import { map } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseRepository } from '@common/data/base';
import { environment } from '@environment/environment';
import { ApiResources } from '@constants/api-resources';
import { AnexoModel } from '@data/anexo/models';
import { FileData } from '@components/anexos/file/file.component';

type Entidade =
  | 'AtendimentosCliente'
  | 'Multas'
  | 'ContratosGrupos'
  | 'OrdemServicos'
  | 'Condutores'
  | 'Medicoes'
  | 'Veiculos';

@Injectable()
export class AnexoRepository extends BaseRepository {
  constructor(http: HttpClient) {
    super(http, environment.serverAuthUrl, ApiResources.ANEXOS);
  }

  getAnexos(entidade: Entidade, chave: string) {
    return this.getRequest<{ data: FileData[] }>({ entidade, chave, offset: 0, limit: 20 }).pipe(
      map((response) => response.data),
    );
  }

  postAnexos(entidade: Entidade, chave: string, anexos: FileData[]) {
    return this.postRequest<{ data: AnexoModel[] }>({ entidade, chave, anexos }).pipe(
      map((response) => response.data),
    );
  }
}
